import { css } from 'lit'

export const buttonBase = css`
  border: none;
  border-radius: 2px;
  cursor: pointer;
  /* Design spec is "Avenir Heavy". The host font kit registers the Heavy face
     at weight 400 (no weight descriptor), so we select it by family at its
     native weight and disable synthesis — requesting 800 on the Book face
     produced faux-bold that rendered differently per host (see DEV-1154). */
  font-family: 'Avenir LT W01_85 Heavy1475544', 'Avenir', sans-serif;
  font-weight: 400;
  font-synthesis: none;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1.4;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`

export const buttonPrimary = css`
  background: transparent;
  border: 1px solid #768d2f;
  color: #768d2f;

  &:hover {
    background-color: rgba(118, 141, 47, 0.1);
  }
`

export const buttonSecondary = css`
  background: #859e3b;
  border: 1px solid rgba(0, 0, 0, 0.08);
  color: #ffffff;

  &:hover {
    background: #7a8f35;
  }
`

export const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const flexBetween = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

export const fadeTransition = css`
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.7;
  }
`